import { instanceToPlain, Expose, } from 'class-transformer';
import { Utilities } from '../utils/Utilities';

export abstract class Model {
	protected _classType: any;
	
	protected _id?: string;
	@Expose()
	set id(newValue: string | undefined) {
		this._id = newValue;
		if (newValue) {
			this._isNew = false;
		}
	}
	get id(): string | undefined {
		return this._id;
	}

	protected _originalState: any;
	protected _isNew = false;

	private _fullyFully = true;

	public ext: any = { };

	constructor(json: any = null) {
		if (json && json.id) {
			this._id = json.id;
		} else {
			this._isNew = true;
		}
	}

	// this gets called after plainToInstance in MarshalModelFactory
	protected _originalJson: any;
	set originalJson(json: any) {
		this._originalJson = json;
		if (json && json.id) {
			this._id = json.id;
			this._isNew = false;
		} else {
			this._isNew = true;
		}
		this._originalState = instanceToPlain(this, { excludePrefixes: ['_'] }) || null;
	}
	get originalJson(): any {
		return this._originalJson;
	}

	isModified(fieldsToIgnore: string[] = []): boolean {
		let modified: boolean = this._isNew;
		let currState: any | null = null;
		if (!modified) {
			currState = instanceToPlain(this, { excludePrefixes: ['_'] });
			if (fieldsToIgnore?.length > 0) {
				fieldsToIgnore.forEach(
					(field: string) => {
						Utilities.removeProperty(currState, field);
					}
				);
			}
			// modified = !Utilities.equalsIgnoreNulls(currState, this._originalState);
			modified = Utilities.differences(currState, this._originalState);
		}
		return modified;
	}

	set originalState(newState: any) {
		this._originalState = newState;
	}
	get originalState(): any {
		return this._originalState;
	}

	isNew(): boolean {
		return this._isNew;
	}

	get fullyLoaded(): boolean {
		return this._fullyFully;
	}
}
